/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo } from "react";
import { SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import "./index.less";
import Context from "@/components/chat/context";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { changeEgovUrl } from "@/utils/tools";
import { tagsNode } from "@/components/AddressBook/common";
import {
  RecommendedType,
  StatusLabels,
  StatusLabelsText,
  StatusLabelsStyles,
  RecommendedTypeTitle
} from "@/services/AppStore";
import { useHistory } from "react-router-dom";
import { getAppStoreUrl } from "@/components/ThirdApp/utils";
import bus from "@/utils/bus";
import { FocusSDK } from "@/utils";

interface IProps {
  message: any;
  sessionType: SessionType;
  sendType: MessageSendType;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  clsName?: string;
  showFooter?: boolean;
}

function ShareAppCard(props: IProps) {
  const history = useHistory();
  const { message, sessionType, clsName, showFooter = true } = props;
  const { currentEmployee, userData } = React.useContext(Context);
  const { authInfo: authData, focusSDK, service, appRuntimeEnv } = React.useContext<
    GlobalContextConfig
  >(GlobalContext);
  const dataInfo = lodashGet(message, "data.0.sharecard", {});
  const appInfo = lodashGet(dataInfo, "ext", {});
  const lables = []
    .concat(appInfo?.networkEnvLabels || [])
    .concat(appInfo?.applicationStatusLabels || []);
  const openCard = useCallback(() => {
    FocusSDK.sendToMain("ai:thridapp:open", appInfo);
  }, [appInfo]);

  const cornerMarkOptions = useMemo(() => {
    const arr = [];
    if ((appInfo?.applicationStatusLabels || []).includes(StatusLabels.UNDER_MAINTENANCE)) {
      arr.push({
        text: StatusLabelsText[StatusLabels.UNDER_MAINTENANCE],
        styles: StatusLabelsStyles[StatusLabels.UNDER_MAINTENANCE]
      });
    }
    if (appInfo?.recommended === RecommendedType.RecommendedYes) {
      arr.push({
        text: RecommendedTypeTitle[RecommendedType.RecommendedYes],
        styles: StatusLabelsStyles.default
      });
    }
    if ((appInfo?.applicationStatusLabels || []).includes(StatusLabels.BETA)) {
      arr.push({
        text: StatusLabelsText[StatusLabels.BETA],
        styles: StatusLabelsStyles[StatusLabels.BETA]
      });
    }
    return arr;
  }, [appInfo]);

  return (
    <div className="share-app-item" style={{ alignItems: "flex-start" }} onClick={openCard}>
      <img className="share-app-item_img" src={changeEgovUrl(dataInfo.avatar)} />
      <div className="share-app-item_right">
        <div className="share-app-item_right_info">
          <div className="share-app-item_title color-primary">{dataInfo.appName}</div>
          {dataInfo && dataInfo.labelInfoList && tagsNode(dataInfo.labelInfoList)}
        </div>
        <p className="share-app-item_text">{dataInfo.brief}</p>
        <div>
          <span className="third-content-item_lable">
            {(appInfo.tags || []).map((item: any) => {
              return <span key={item.tagId}>{item.name}</span>;
            })}
            {lables.concat(appInfo?.applicationStatusLabels || []).map((key: any, index: any) => {
              const text = StatusLabelsText[key];
              if (
                cornerMarkOptions.find((item: any) => item.text === text) ||
                text === StatusLabelsText[StatusLabels.VPN]
              ) {
                return "";
              }
              return <span key={"net" + index}>{text}</span>;
            })}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ShareAppCard;
